var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2507 16.0417V20.4167H3.75065V16.0417H0.833984V20.4167C0.833984 22.0208 2.14648 23.3333 3.75065 23.3333H21.2507C22.8548 23.3333 24.1673 22.0208 24.1673 20.4167V16.0417H21.2507ZM19.7923 10.2083L17.7361 8.15208L13.959 11.9146V0H11.0423V11.9146L7.26523 8.15208L5.20898 10.2083L12.5007 17.5L19.7923 10.2083Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f4001b4a6f09a13a4ec7d1fbd5d11444.svg";
export { ForwardRef as ReactComponent };